import * as React from 'react';
import Model from './personalinfo-model';
import BasePicklist from '../base/base-picklist.component';

interface IProps {
  personalinfotypeType?: string; 
  currentId?: number;  
  scheduleId?: number;  
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class PersonalinfoPicklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklist endPointFilter={Model.endPointFilterList(this.props.personalinfotypeType, this.props.scheduleId)} model={Model} currentId={this.props.currentId} onLoad={this.props.onLoad} disableBackButton/>
    );
  }
}
